import styled from '@emotion/styled';
import Typography from '@mui/material/Typography';
import { Theme } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
    isWebView: string;
    primaryshow: string;
}

export const ContentCart = styled('div')(
    ({ theme, primaryshow, isWebView }: ParamsStyle) => `
        position: fixed;
        overflow: hidden;
        width: 100%;
        left: 0;
        right: 0;
        bottom: ${isWebView === 'active' ? '0px' : '59px'};
        display: flex;
        max-height: 100%;
        align-items: center;
        transition: all 200ms;
        justify-content: center;

        @media(max-width: ${theme?.breakpoints.values.sm}px) {
            &.open {
                animation: is-open .5s ease-in-out;
                animation-fill-mode: forwards;
    
                @keyframes is-open {
                    0% {
                        height: 65px;
                    }
                    100% {
                        height: 100%;
                    }
                }
            }
    
            &.close {
                animation: is-close ${primaryshow === 'active' ? '400ms' : '0s'}  ease-in-out;
                animation-fill-mode: forwards;
    
                @keyframes is-close {
                    0% {
                        height: 100%;
                    }
                    100% {
                        height: 65px;
                    }
                }
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            position: relative;
            bottom: 0px;
            width: 100%;
            height: 100%;
            max-width: 19rem;
            max-height: 100%;
            background-color: #EFF2F5;
        }
`);

export const Container = styled('div')(
    ({ theme }: { theme?: Theme; }) => `
        width: 100%;
        height: fit-content;
        position: absolute;
        max-width: 100%;
        transition: all 200ms;
        padding: 1.2rem 1.5rem 3rem;
        border-radius: 10px 10px 0px 0px;
        box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
        background-color: ${theme?.palette.primary.main};

        h5 {
            text-align: center;
            font-size: 1.25rem;
        }

        &.open {
            bottom: 0;
            top: auto;
        }
        
        &.close {
            top: 0;
            bottom: auto;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            position: fixed;
            width: 100%;
            height: auto;
            top: 25%;
            bottom: auto;
            max-width: 19rem;
            transition: all 0ms;
            border-radius: 10px;
            padding: 1.5rem 1.125rem;

            h5 {
                font-size: 1.875rem;
                max-width: 11.125rem;
            }
            
            &.close {
                top: 25%;
                height: fit-content;
            }
            
            &.open {
                top: 25%;
                bottom: auto;
            }
        }
`);

export const RiskWhite = styled('div')(
    ({ theme }: { theme?: Theme; }) => `
        width: 3.125rem;
        height: .3rem;
        background: #FFFFFF;
        border-radius: 10px;
        margin: 0 auto .75rem;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            display: none;
        }
`);

export const ContentPlan = styled('div')(
    ({ theme }: { theme?: Theme; }) => `
        nav {
            display: flex;
            position: relative;
            margin-bottom: 1.5rem;
            border-bottom: 1px solid #ECECEC;

            h6 {
                font-weight: 700;
                font-size: 1.1rem;
                border-radius: 5px 5px 0px 0px;
                background: ${theme?.palette.secondary.main};
            }

            button {
                position: absolute;
                right: 0;
                width: 80px;
                height: 30px;
                bottom: -.93rem;
                cursor: pointer;
                line-height: 14px;
                font-size: .81rem;
                border-radius: 100px;
                background-color: #ffffff;
                color: ${theme?.palette.grey[400]};
                border: 1.5px solid ${theme?.palette.grey[400]};

                :disabled {
                    cursor: not-allowed;
                    color: rgba(255,255,255, .8);
                    background-color: ${theme?.palette.grey[100]};
                }
            }
        }
`);

export const AdditionalServices = styled('ul')(`
    gap: .5rem;    
    display: flex;
    flex-direction: column;

    &::-webkit-scrollbar { 
        display: none;
    }

    li {
        display: flex;
        align-items: start;
        justify-content: space-between;
        h6 {
            font-size: .8rem;
            max-width: 10rem;
        }
    }
`);

export const ContentTotal = styled('div')(
    ({ theme }: { theme?: Theme; }) => `
        margin-top: 1rem;

        nav {
            margin-bottom: .8rem;
            border-bottom: 1px solid #ECECEC;

            h6 {
                border-radius: 5px 5px 0px 0px;
                background: ${theme?.palette.secondary.main};
            }
        }

        button {
            width: 100%;
            margin-top: 1.5rem;
        }
`);

export const ContentRemove = styled('button')(
    ({ theme }: { theme?: Theme; }) => `
        position: absolute;
        right: 85px;
        width: 15px;
        height: 15px;
        cursor: pointer;
        border-radius: 100px;
        background-color: #FFFFFF;
        border: none;
        display: flex;
        text-align: center;
        padding: 0 0 0 1px;
        align-items: center;
        margin: 0 1rem 3px 0;
        justify-content: center;
    
        svg {
            width: 8px;
            height: 8px;
        }
    
        :disabled {
            cursor: not-allowed;
            color: rgba(255,255,255, .8);
            background-color: ${theme?.palette.grey[100]};
        }
`);

export const TypographyText = styled(Typography)(`
    padding: 0;
    color: white;
    font-weight: 700;
    max-width: 11.25rem;
    width: fit-content;
`);

export const ContentButton = styled('div')(
    ({ theme }: { theme?: Theme; }) => `
        display: none;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            display: block;

            button {
                width: 100%;
            }
        }
`);